import {
  CButton,
  CCard,
  CCol,
  CFormInput,
  CFormLabel,
  CRow,
  CCardHeader,
  CCardBody,
} from "@coreui/react";
import React, { useEffect, useRef, useState } from "react";
import authInstance from "src/api/apiConfig";
import "./bankstatement.css";
import { errorAlert } from "src/utils/Swal";
import { useReactToPrint } from "react-to-print";
import {
  COMPANY_Address,
  COMPANY_NAME,
  Loader,
} from "src/services/const";

const BankStatement = () => {
  // const [balanceData, setBalanceData] = useState([]);
  const componentPDF = useRef();
  const [allData, setAllData] = useState();
  const initial = { startDate: "", endDate: "" };
  const [formValues, setFormValues] = useState(initial);
  const { startDate, endDate } = formValues;
  const [printState, setPrintState] = useState(false);
  const [loader, setLoader] = useState(false);
  const schemaName = sessionStorage.getItem("schemaName");

  const handleChange = (e) => {
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };

  const handleAllCustomerTotal = async () => {
    try {
      const payload = {
        schemaName,
        startDate,
        endDate,
      };
      setLoader(true);
      const response = await authInstance.post("/getallwithdate", payload);
      if (response.status === 200) {
        setAllData(response?.data?.totals);
      }
    } catch (error) {
      errorAlert("failed", "Some-thing Went Wrong");
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    // handleBalanceSheet();
    handleAllCustomerTotal();
  }, []);

  // const directors = balanceData.directors || [];
  // const accountData = balanceData.getAllAccountData || [];
  // const disbursments = balanceData.getAllDisbursments || [];
  // const interests = balanceData.getAllInterests || [];
  // const profitAndLoss = balanceData.getProfitAndLoss || [];
  // const penalties = balanceData.getTotalPenaltyAmount || [];

  // const maxLength = Math?.max(
  //   directors.length,
  //   accountData.length,
  //   disbursments.length,
  //   interests.length,
  //   profitAndLoss.length,
  //   penalties.length
  // );

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "userData",
    onAfterPrint: () => setPrintState(false),
  });

  useEffect(() => {
    if (printState) {
      generatePDF();
    }
  }, [printState]);

  const handlePrint = () => {
    setPrintState(true);
  };

  return (
    <div className="modern-content">
      <CCard className="mb-4 modern-card">
        <CCardHeader className="modern-header">
          <div className="company-header">
            <img src="logo.png" alt="Logo" className="logo" />
            <div>
              <h3 className="modern-title">{COMPANY_NAME}</h3>
              <span className="modern-address">{COMPANY_Address}</span>
            </div>
          </div>
        </CCardHeader>
        <CCardBody>
          <CRow className="date-row">
            <CCol md={4}>
              <CFormLabel className="modern-label">Start Date</CFormLabel>
              <CFormInput
                type="date"
                value={startDate}
                name="startDate"
                className="modern-input"
                onChange={handleChange}
              />
            </CCol>
            <CCol md={4}>
              <CFormLabel className="modern-label">End Date</CFormLabel>
              <CFormInput
                type="date"
                value={endDate}
                name="endDate"
                className="modern-input"
                onChange={handleChange}
              />
            </CCol>
            <CCol md={4} className="btn-align">
              {loader ? (
                <Loader />
              ) : (
                <CButton
                  className="modern-btn search-btn"
                  onClick={handleAllCustomerTotal}
                >
                  Search
                </CButton>
              )}
              <CButton
                className="modern-btn download-btn"
                onClick={handlePrint}
                color="secondary"
              >
                Download PDF
              </CButton>
            </CCol>
          </CRow>

          <div className="modern-pdf" ref={componentPDF}>

            <div className="section-title">All Customer Account Details</div>
            <CCard className="modern-details-card">
              <CCardBody>
                <CRow className="g-3">
                  <CCol md={4}>
                    <CFormLabel>Total Disbursement</CFormLabel>
                    <CFormInput
                      value={
                        Number(allData?.totalDisbursementAmount) +
                        Number(allData?.totalFileCharges) +
                        Number(allData?.totalOtherCharges) ?? "--"}
                      disabled
                      className="modern-disabled-input"
                    />
                  </CCol>
                  <CCol md={4}>
                    <CFormLabel>Total File Charges</CFormLabel>
                    <CFormInput
                      value={allData?.totalFileCharges ?? "--"}
                      disabled
                      className="modern-disabled-input"
                    />
                  </CCol>
                  <CCol md={4}>
                    <CFormLabel>Total Other Charges</CFormLabel>
                    <CFormInput
                      value={allData?.totalOtherCharges ?? "--"}
                      disabled
                      className="modern-disabled-input"
                    />
                  </CCol>
                  <CCol md={4}>
                    <CFormLabel>Total Principal Amount</CFormLabel>
                    <CFormInput
                      value={
                        Number(allData?.totalDisbursementAmount) +
                        Number(allData?.totalFileCharges) +
                        Number(allData?.totalOtherCharges) ?? "--"}
                      disabled
                      className="modern-disabled-input"
                    />
                  </CCol>
                  <CCol md={4}>
                    <CFormLabel>Total Principal Amount Received</CFormLabel>
                    <CFormInput
                      value={
                        (Number(allData?.totalPaymentAmount) -
                          (Number(allData?.totalPaidInterestAmount) - Number(allData?.totalDiscountAmount))).toFixed(2)
                        ?? "--"}
                      disabled
                      className="modern-disabled-input"
                    />
                  </CCol>
                  <CCol md={4}>
                    <CFormLabel>Total Balance Principal Amount</CFormLabel>
                    <CFormInput
                      value={
                        ((Number(allData?.totalDisbursementAmount) +
                          Number(allData?.totalFileCharges) +
                          Number(allData?.totalOtherCharges)) -
                          (Number(allData?.totalPaymentAmount) -
                            (Number(allData?.totalPaidInterestAmount) - Number(allData?.totalDiscountAmount)))).toFixed(2)
                        ?? "--"}
                      disabled
                      className="modern-disabled-input"
                    />
                  </CCol>
                  <CCol md={4}>
                    <CFormLabel>Total EMI Amount</CFormLabel>
                    <CFormInput
                      value={allData?.totalEmiAmount ?? "--"}
                      disabled
                      className="modern-disabled-input"
                    />
                  </CCol>
                  <CCol md={4}>
                    <CFormLabel>Total Due EMI Amount</CFormLabel>
                    <CFormInput
                      value={allData?.totalDueEmiAmount ?? "--"}
                      disabled
                      className="modern-disabled-input"
                    />
                  </CCol>
                  <CCol md={4}>
                    <CFormLabel>Total Interest</CFormLabel>
                    <CFormInput
                      value={
                        allData?.totalInterestAmount !== undefined && allData?.totalInterestAmount !== null
                          ? Number(allData.totalInterestAmount).toFixed(2)
                          : "--"
                      }
                      disabled
                      className="modern-disabled-input"
                    />
                  </CCol>
                  <CCol md={4}>
                    <CFormLabel>Total Received Interest</CFormLabel>
                    <CFormInput
                      value={
                        allData?.totalPaidInterestAmount !== undefined && allData?.totalPaidInterestAmount !== null
                          ? Number(allData.totalPaidInterestAmount).toFixed(2)
                          : "--"
                      }
                      disabled
                      className="modern-disabled-input"
                    />
                  </CCol>
                  <CCol md={4}>
                    <CFormLabel>Total Payment Received</CFormLabel>
                    <CFormInput
                      value={allData?.totalPaymentAmount ?? "--"}
                      disabled
                      className="modern-disabled-input"
                    />
                  </CCol>
                  <CCol md={4}>
                    <CFormLabel>Total Penalty</CFormLabel>
                    <CFormInput
                      value={allData?.totalPenaltyAmount ?? "--"}
                      disabled
                      className="modern-disabled-input"
                    />
                  </CCol>
                  <CCol md={4}>
                    <CFormLabel>Total Discount Amount</CFormLabel>
                    <CFormInput
                      value={allData?.totalDiscountAmount ?? "--"}
                      disabled
                      className="modern-disabled-input"
                    />
                  </CCol>
                  <CCol md={4}>
                    <CFormLabel>Total Expense Amount</CFormLabel>
                    <CFormInput
                      value={allData?.totalExpenseAmount ?? "--"}
                      disabled
                      className="modern-disabled-input"
                    />
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>

            {/* <div className="section-title">Director & Account Details</div>
            {maxLength > 0 ? (
              Array.from({ length: maxLength }).map((_, index) => (
                <CCard key={index} className="modern-details-card mb-3">
                  <CCardBody>
                    <CRow className="g-3">
                      <CCol md={4}>
                        <CFormLabel>Director Name</CFormLabel>
                        <CFormInput
                          value={directors[index]?.directorName || "N/A"}
                          disabled
                          className="modern-disabled-input"
                        />
                      </CCol>
                      <CCol md={4}>
                        <CFormLabel>Capital</CFormLabel>
                        <CFormInput
                          value={directors[index]?.capital || "N/A"}
                          disabled
                          className="modern-disabled-input"
                        />
                      </CCol>
                      <CCol md={4}>
                        <CFormLabel>Account Name</CFormLabel>
                        <CFormInput
                          value={accountData[index]?.accountName || "N/A"}
                          disabled
                          className="modern-disabled-input"
                        />
                      </CCol>
                      <CCol md={4}>
                        <CFormLabel>Disbursement</CFormLabel>
                        <CFormInput
                          value={disbursments[index]?.disbursementamount || "N/A"}
                          disabled
                          className="modern-disabled-input"
                        />
                      </CCol>
                      <CCol md={4}>
                        <CFormLabel>Interest</CFormLabel>
                        <CFormInput
                          value={interests[index]?.interestamount || "N/A"}
                          disabled
                          className="modern-disabled-input"
                        />
                      </CCol>
                      <CCol md={4}>
                        <CFormLabel>Total Amount</CFormLabel>
                        <CFormInput
                          value={profitAndLoss[index]?.totalamount || "N/A"}
                          disabled
                          className="modern-disabled-input"
                        />
                      </CCol>
                      <CCol md={4}>
                        <CFormLabel>Penalty</CFormLabel>
                        <CFormInput
                          value={penalties[index]?.penaltyAmount || "N/A"}
                          disabled
                          className="modern-disabled-input"
                        />
                      </CCol>
                    </CRow>
                  </CCardBody>
                </CCard>
              ))
            ) : (
              <div className="text-center p-3">Loading...</div>
            )} */}
          </div>
        </CCardBody>
      </CCard>
    </div>
  );
};
export default BankStatement;
